import type { DanceSeoHead } from "../danceSeoTypes.js";

// pt translation of the English source (shared/danceSeoHeads/en.ts); numbers must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Gerador de vídeos de dança com IA a partir de música",
    description:
      "Transforme qualquer música em um vídeo de dança com IA. A Solmi planeja a coreografia de cada seção e renderiza cenas de dança e lip-sync. Grátis para começar.",
    h1: "Gerador de vídeos de dança com IA: transforme qualquer música em um vídeo de dança",
  },
  photo: {
    title: "Fazer uma foto dançar com IA: sua foto dançando | Solmi",
    description:
      "Faça uma foto dançar com IA: envie uma foto de corpo inteiro, escolha um passo ou seu clipe e adicione uma música. A Solmi ajusta à batida. Grátis para começar.",
    h1: "Faça uma foto dançar: gerador de dança com IA a partir de foto",
  },
  inbound:
    "Quer que o artista dance? O [gerador de vídeos de dança com IA](/ai-dance-video-generator) planeja a coreografia de cada seção da sua música e renderiza um vídeo de dança completo.",
};

export default head;
